module.exports = __webpack_public_path__ + "img/ic_property_semidetached.c3da0bb0.svg";